import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
    return twMerge(clsx(inputs));
}

export function clamp(value: number, min: number, max: number): number {
    return Math.max(min, Math.min(max, value));
}

/**
 * areShallowEqualValues — shallow equality for flat string→value maps (e.g.
 * settings drafts vs. their saved baseline). Null/undefined operands are
 * unequal unless identical.
 */
export function areShallowEqualValues(
    a: Record<string, unknown> | null | undefined,
    b: Record<string, unknown> | null | undefined,
): boolean {
    if (a === b) { return true; }
    if (!a || !b) { return false; }
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    if (keysA.length !== keysB.length) { return false; }
    for (const k of keysA) {
        if (a[k] !== b[k]) { return false; }
    }
    return true;
}

// "preRecordSec" -> "Pre record sec", "deviceId" -> "Device id".
export function humanizeKey(key: string): string {
    const words = key
        .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
        .replace(/[_-]+/g, ' ')
        .toLowerCase()
        .trim();
    if (!words) { return ''; }
    return words.charAt(0).toUpperCase() + words.slice(1);
}
